/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WizardValidationErrorDto
 */
export interface WizardValidationErrorDto {
    /**
     * 
     * @type {string}
     * @memberof WizardValidationErrorDto
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof WizardValidationErrorDto
     */
    message: string;
}

/**
 * Check if a given object implements the WizardValidationErrorDto interface.
 */
export function instanceOfWizardValidationErrorDto(value: object): value is WizardValidationErrorDto {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function WizardValidationErrorDtoFromJSON(json: any): WizardValidationErrorDto {
    return WizardValidationErrorDtoFromJSONTyped(json, false);
}

export function WizardValidationErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WizardValidationErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'message': json['message'],
    };
}

export function WizardValidationErrorDtoToJSON(json: any): WizardValidationErrorDto {
    return WizardValidationErrorDtoToJSONTyped(json, false);
}

export function WizardValidationErrorDtoToJSONTyped(value?: WizardValidationErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'message': value['message'],
    };
}

